module.exports = __webpack_public_path__ + "img/modelo_small14.0e3cf341.png";